<template>
    <div class="limiter">
        <div class="container-login100">
            <div class="wrap-login100">
                <v-container fluid>
                    <v-row align="center" justify="center">
                        <v-card  class="login100-form" flat style="border-radius: 15px;">
                            <span class="login100-form-title">
                                <img src="../assets/AI.png" width="100%" style="max-width: 300px">
                            </span> 
                            <v-card-text>
                                <v-layout row wrap justify-center>
                                    <v-flex xs10 sm10 lg9>
                                        <v-text-field
                                            color="#474d55"
                                            light
                                            label="E-mail"
                                            single-line
                                            outlined
                                            dense
                                            v-model="user.email" name="email" type="text"
                                            :rules="emailRules"
                                            required
                                            prepend-inner-icon="email"
                                        ></v-text-field>
                                    </v-flex>
                                    <v-flex xs10 sm10 lg9>
                                        <v-text-field
                                            color="#474d55"
                                            label="Senha"
                                            single-line
                                            outlined
                                            dense
                                            v-model="user.password" name="password"
                                            :rules="passwordRules"
                                            required
                                            prepend-inner-icon="lock"
                                            :append-icon="show1 ? 'visibility' : 'visibility_off'"
                                            :type="show1 ? 'text' : 'password'"
                                            @click:append="show1 = !show1"
                                            @keydown.enter="signin"
                                        />
                                    </v-flex>
                                    <v-flex xs10 sm10 lg9 v-if="!usuarioLogado">       
                                        <v-btn dark :loading="loading" depressed block color="#474d55" style="border-radius: 7px;" large @click="signin">Acessar</v-btn>        
                                    </v-flex> 
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-row>
                    <br>
                    <div class="login100-form-title">
                        <a href="https://www.intelitetecnologia.com.br/" target="_blank">
                            <img src="../assets/LogoBrancoHorizontal.png" width="130px">
                        </a>
                    </div>
                    <br>
                </v-container>
			</div>
		</div>
    <Snackbar ref=chamaSnackbar />
	</div>
</template>

<script>
    import { userKey, baseApiUrl } from '@/global'
    import Snackbar from '../componentes/snackbar.vue'
    import { mapState } from 'vuex'
    import axios from 'axios'
    export default {
        components: {Snackbar},
        name: 'Auth',
        computed: mapState({
            usuarioLogado: state => state.isMenuVisible,
        }),
        data: function() {
            return {
                loading: false,
                countAccess: '',
                userObj: [],
                show1: false,
                token: "",
                userId: "",
                showSignup: false,
                showAlterPass: false,
                userPemission: "",
                user: {},
                emailRules: [
                    v => !!v || 'E-mail é obrigatório',
                    v => /.+@.+/.test(v) || 'E-mail não é válido'
                ],
                nameRules: [
                    v => !!v || 'Nome é obrigatório'
                ],
                passwordRules: [
                    v => !!v || 'Senha é obrigatório'
                ]         
            }
        },

        mounted: function () {
            if (sessionStorage.getItem('accToken') != null)
                this.$router.push({ path: '/home' })
            if (sessionStorage.getItem('userPermission') != null)
                this.$store.dispatch('Permission')
            if (sessionStorage.getItem('accToken') != null)
                this.$store.dispatch('Logar', this.token)
        },

        methods: {
            async signin() {
                this.loading = true
                if ((this.user.email != null) || (this.user.password != null)) {
                    await axios.post(baseApiUrl + 'Usuarios/login', this.user)
                    .then(response => {
                        this.token = response.data.id
                        this.userId = response.data.userId
                        this.verificaUsuario()
                    })
                    .catch(() => {
                        this.loading = false  
                        var vm = this;          
                        vm.$refs.chamaSnackbar.snack("#EF5350","Usuário e senha inválidos. Corrija e tente novamente!","ERRO")
                    })
                } else {
                    this.loading = false
                    var vm = this;
                    vm.$refs.chamaSnackbar.snack("#F9A825","Preencha os campos de E-mail e Senha!","ATENÇÃO")
                }
            },

            Sair() {
                this.$store.dispatch('Sair')
            },

            async verificaUsuario() {
                if (this.userId != '') {
                    await axios.get(baseApiUrl + 'Usuarios/' + this.userId + '?access_token=' + this.token)
                    .then(res => {
                        if (res.data.tipo === "GERENTE" || res.data.tipo === "ADMIN"  || res.data.tipo === "RECEPCAO"  && res.data.ativo === true) {
                            sessionStorage.setItem('accToken', this.token)
                            this.userPemission = res.data.tipo
                            this.user.username = res.data.nome
                            this.userObj = res.data
                            sessionStorage.setItem(userKey, JSON.stringify(this.userPemission))
                            sessionStorage.setItem('userPermission', this.userPemission)
                            sessionStorage.setItem('userName', this.user.username)
                            sessionStorage.setItem('user', JSON.stringify(res.data))
                            this.$store.dispatch('SetUser')
                            this.$store.dispatch('Permission')
                            this.$store.dispatch('SetUserName')
                            this.$store.dispatch('Logar', this.token)
                            this.verificaCompany()
                            this.$router.push({ path: '/home' })
                        } else {
                            sessionStorage.clear()
                            this.loading = false
                            var vm = this;
                            vm.$refs.chamaSnackbar.snack("#F9A825","Usuário inativo ou sem permissão de acesso!", "ATENÇÃO")
                        }
                    })
                    .catch(() => {
                        //
                    })
                }
            },
                
            verificaCompany() {
                axios.get(baseApiUrl + 'Empresas/' + this.userObj.empresaId)
                .then(response => {
                    sessionStorage.setItem('company', JSON.stringify(response.data))
                    this.$store.dispatch('SetCompany')
                    this.loading = false
                })
                .catch(() => {
                    this.loading = false
                    var vm = this
                    vm.$refs.chamaSnackbar.snack("#EF5350","Problema ao consultar empresa", "DESCULPE")
                })
            },
        }
    }
</script>

<style>
    /* LOGIN */
    .limiter {
        width: 100%;
        margin: 0 auto;
    }

    .container-login100 {
        width: 100%;
        min-height: 100vh;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        align-items: center;
        padding: 15px;
        background: linear-gradient(to right, #474d55, #474d55);
        background-repeat: no-repeat;
        position: relative;
        z-index: 1;
    }

    .wrap-login100 {
        width: 400px;
        overflow: hidden;
        background: transparent;
    }

    /* [ Form ] */
    .login100-form {
        max-width: 90%;
        border-radius: 15px;
        background-color: #fff;
        opacity: 0.9;
        padding-top: 15px;
        padding-bottom: 15px;
    }

    .login100-form-title {
        display: block;
        margin-left: auto;
        margin-right: auto;
        text-align: center
    }

    .linkapp {
        text-decoration: none;
        color: white;
        font-size: 9px;
    }
</style>
